import type { LabeledStat } from '@/components/common/StatCardGrid';
import { getActiveStatCard, getInactiveStatCard } from '@/utils/activeStatCards';
import type {
  BookEditionResponse,
  BookTypeResponse,
  SpecimenDistributionResponse,
  SpecimenResponse,
} from '../types/product.types';

function getSpecimenCountStatCard(specimens: number | undefined): LabeledStat {
  return {
    key: 'specimens',
    label: 'Specimens',
    value: specimens,
  };
}

function getBookTypeCountStatCard(bookTypes: number | undefined, label: string): LabeledStat {
  return { key: 'bookTypes', label, value: bookTypes };
}

export function getBookTypeStatCards(meta: BookTypeResponse['meta'] | undefined): LabeledStat[] {
  return [
    getBookTypeCountStatCard(meta?.total, 'Book Types'),
    getActiveStatCard(meta?.totals),
    getInactiveStatCard(meta?.totals),
    getSpecimenCountStatCard(meta?.totals.specimens),
  ];
}

export function getBookEditionStatCards(
  meta: BookEditionResponse['meta'] | undefined,
): LabeledStat[] {
  return [
    { key: 'editions', label: 'Editions', value: meta?.total },
    getActiveStatCard(meta?.totals),
    getInactiveStatCard(meta?.totals),
    getSpecimenCountStatCard(meta?.totals.specimens),
  ];
}

export function getSpecimenDistributionStatCards(
  meta: SpecimenDistributionResponse['meta'] | undefined,
): LabeledStat[] {
  const totals = meta?.totals;
  return [
    {
      key: 'givenSpecimens',
      label: 'Specimen Titles',
      value: totals?.givenSpecimens,
    },
    {
      key: 'distributed',
      label: 'Distributed Qty',
      value: totals?.distributedQty,
    },
    {
      key: 'pendingQty',
      label: 'Pending Approval',
      value: totals?.pendingQty,
    },
    { key: 'zms', label: 'ZMs', value: totals?.zms },
    {
      key: 'institutions',
      label: 'Institutions',
      value: totals?.institutions,
    },
  ];
}

export function getSpecimenListStatCards(
  meta: SpecimenResponse['meta'] | undefined,
): LabeledStat[] {
  return [
    getSpecimenCountStatCard(meta?.total),
    getActiveStatCard(meta?.totals),
    getInactiveStatCard(meta?.totals),
    getBookTypeCountStatCard(meta?.totals.bookTypes, 'Book Types Used'),
  ];
}
